//Imports
import es from 'date-fns/locale/es';
import { Button, Form, Row, Col } from 'react-bootstrap';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { faCalendarAlt, faFilter } from '@fortawesome/free-solid-svg-icons';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, forwardRef, useEffect, useRef, useMemo, useCallback } from 'react';
import { AlertaService, GruposService, VehiculosService, GeocercaService } from '../../../services/apiService';
import reporteTiempoStore, { tiposVista } from '../../../lib/store/reporte_tiempo_store';
import dayjs from 'dayjs';
import { jwtDecode } from 'jwt-decode';
import { paginadoRecorridosStore } from '../../../lib/store/paginador_store';
import { MultiSelect } from 'primereact/multiselect';
import { sortBy } from "underscore";
import { AccionBitacora, generarObservacion, guardarBitacora } from '../../../utils/bitacora';
import { createRenderCustomHeader } from '../../../components/datepicker/CustomDatePickerHeader';
import { handleStartDateChange, handleEndDateChange } from '../../../utils/datePickerUtils';
import '../../../styles/datepicker.css'

// Registrar la localización en español para DatePicker
registerLocale('es', es);
setDefaultLocale('es');

const FiltersNonWorkingHours = ({ onGenerateReport, imprimir, onToggleDebug }) => {

    const effectRan = useRef(false);
    /*STORE*/
    const { editarTipoVista, editarGrupos, editarVehiculos, editarFechaInicio, editarFechaFin, editarAlertas } = reporteTiempoStore();

    const paginadorRecorridos = paginadoRecorridosStore();
    /*STORE*/

    /*VARIABLES DE USO LOCAL*/

    const [cargandoGruposLocal, editarCargandoGruposLocal] = useState(false);
    const [gruposLocal, editarGruposLocal] = useState([]);
    const [selGruposLocal, editarSelGruposLocal] = useState([]);

    const [cargandoVehiculosLocal, editarCargandoVehiculosLocal] = useState(false);
    const [vehiculosLocal, editarVehiculosLocal] = useState([]);
    const [vehiculosLocalFiltrados, editarVehiculosLocalFiltrados] = useState([]);
    const [selVehiculosLocal, editarSelVehiculosLocal] = useState([]);

    const [selTipoVista, editarSelTipoVista] = useState(tiposVista[1]);

    const [cargandoTipoAlertas, editarCargandoTipoAlertas] = useState(false);
    const [tipoAlertas, editarTipoAlertas] = useState([]);

    const [geocercas, setGeocercas] = useState([]);

    // Establecer valores iniciales para las fechas
    const now = new Date();
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0); // Inicio del día (00:00:00)
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59); // Fin del día (23:59:59)
    const minDateInicio = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 29, 0, 0, 0);
    const minDateFin = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 29, 0, 0, 0);

    // Inicializar fechas con el día actual
    const [startDate, setStartDate] = useState(startOfDay);
    const [endDate, setEndDate] = useState(endOfDay);
    const [dateRangeError, setDateRangeError] = useState("");
    // Validación de rango de fechas (máximo 1 día)
    useEffect(() => {
        if (startDate && endDate) {
            const diffInMs = endDate - startDate;
            const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
            if (diffInDays > 15) {
                setDateRangeError("El rango de fechas no puede exceder 15 días.");
            } else {
                setDateRangeError("");
            }
        }
    }, [startDate, endDate]);

    /*VARIABLES DE USO LOCAL*/

    // Personalizar la vista del Select
    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: '34px',
            overflow: 'hidden'
        }),
        valueContainer: (provided) => ({
            ...provided,
            maxHeight: '34px',
            overflow: 'hidden'
        })
    };

    //Estilo de los time pickers
    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <div className="position-relative">
            <Form.Control ref={ref} onClick={onClick} value={value} onChange={() => { }} />
        </div>
    ));

    // 👥 Cargar Grupos
    const cargarGruposLocal = async () => {
        if (cargandoGruposLocal)
            return;
        editarCargandoGruposLocal(true);
        try {
            const response = await GruposService.getGrupos();
            if (response && response.statusCode === 200) {
                const gruposData = response.data.map((grupo) => ({
                    value: grupo.uid_grupo,
                    label: `${grupo.nombre}`,
                    uid_grupo: grupo.uid_grupo
                }));
                editarGruposLocal(gruposData);
            }
        } catch (error) {
            console.error("Error cargando los grupos:", error);
        } finally {
            editarCargandoGruposLocal(false);
        }
    };



    // Obtiene los Vehículos
    const cargarVehiculosLocal = async () => {
        if (cargandoVehiculosLocal)
            return;
        editarCargandoVehiculosLocal(true);
        try {
            //Servicio vehiculos 
            const response = await VehiculosService.getVehiculos();

            //Valida los datos obtenidos
            if (response && response.statusCode === 200) {

                //Aplicamos orden alfabetico
                //const _vehiculos = sortBy(response.data, function (i) { return i.alias.trim().toUpperCase() })
                const _vehiculos = sortBy(response.data, function (i) { return (i.alias ?? "").trim().toUpperCase() });


                //listado de imputs para el select
                const vehiculosData = _vehiculos.map(vehiculo => ({
                    value: vehiculo.uid_vehiculo,
                    label: `${vehiculo.no_economico} / ${vehiculo.alias ?? ""}`,
                    uid_grupo: vehiculo.uid_grupo,
                    no_economico: vehiculo.no_economico,
                    alias: `${vehiculo.alias}`,
                    id: vehiculo.id_vehiculo,
                    horario_empresa: vehiculo.horario_empresa,
                    horario_vehiculo: vehiculo.horario_vehiculo,
                    tipo_vehiculo: vehiculo.tipo_vehiculo,
                    color_vehiculo: vehiculo.color_vehiculo
                }));

                //llena los vehiculos
                editarVehiculosLocal(vehiculosData);
            }
        } catch (error) {
            console.error("Error cargando vehículos:", error);
        } finally {
            editarCargandoVehiculosLocal(false);
        }
    };

    // 👥 Cargar tipo alertas
    const cargarTipoAlertas = async () => {
        if (cargandoTipoAlertas)
            return;
        editarCargandoTipoAlertas(true);
        try {
            const response = await AlertaService.getTipoAlertaQuro();
            if (response && response.statusCode === 200) {
                const alertasIdList = (response.data.sort((a, b) => a.orden - b.orden)).map(item => { return item.tipo_alerta });
                editarTipoAlertas(alertasIdList);
                editarAlertas(response.data.sort((a, b) => a.orden - b.orden));
            }
        } catch (error) {
            console.error("Error cargando los tipo de alertas:", error);
        } finally {
            editarCargandoTipoAlertas(false);
        }
    };

    const loadGeocercas = async () => {
        try {
            const response = await GeocercaService.getGeocercas();
            if (response && response.statusCode === 200) {
                console.log(response);
                const _geocercas = sortBy(response.data, function (i) { return i.nombre.trim().toUpperCase() })

                setGeocercas(_geocercas);
            }
        } catch (err) {
            console.error("Error cargando geocercas:", err);
        }
    };

    useEffect(() => {

        // Obtener TODOS los grupos seleccionados (no solo uno)
        const gruposSeleccionados = gruposLocal.filter(grupo =>
            selGruposLocal.some(selGrupo =>
                typeof selGrupo === 'object'
                    ? selGrupo.value === grupo.value
                    : selGrupo === grupo.value
            )
        );

        if (gruposSeleccionados.length > 0) {

            // Obtener los UUIDs de los grupos seleccionados
            const uidsGruposSeleccionados = gruposSeleccionados.map(g => g.value);

            // Filtrar vehículos que pertenecen a ALGUNO de los grupos seleccionados
            const filtrados = vehiculosLocal.filter(vehiculo =>
                uidsGruposSeleccionados.includes(vehiculo.uid_grupo)
            );

            if (filtrados)
                editarVehiculosLocalFiltrados(filtrados);

            // Filtrar elementos ya seleccionados que pertenecen a los grupos seleccionados
            const vehiculosSeleccionados = vehiculosLocal.filter(vehiculo =>
                selVehiculosLocal.some(selVehiculo =>
                    typeof selVehiculo === 'object'
                        ? selVehiculo.value === vehiculo.value
                        : selVehiculo === vehiculo.value
                )
            );

            const filtradosSelected = vehiculosSeleccionados.filter(vehiculo =>
                uidsGruposSeleccionados.includes(vehiculo.uid_grupo)
            );

            //editarSelVehiculosLocal(filtradosSelected);
            editarSelVehiculosLocal([])
        } else {
            // Si no se selecciona grupo, mostrar todos los vehículos
            editarVehiculosLocalFiltrados(vehiculosLocal);
            editarSelVehiculosLocal([])
        }
    }, [selGruposLocal, vehiculosLocal]);

    // useEffect(() => {
    //     debugger;


    //     const grupossselec = gruposLocal.find(grupo =>
    //         selGruposLocal.includes(grupo.value)
    //     );

    //     if (grupossselec && grupossselec.value) {
    //         // Filtrar los vehículos que pertenecen al grupo seleccionado
    //         const filtrados = vehiculosLocal.filter(
    //             (vehiculo) => vehiculo.uid_grupo === grupossselec.value
    //         );
    //         editarVehiculosLocalFiltrados(filtrados);
    //         /*Filtrar elementos ya seleccionados*/
    //         const vehiculosSeleccionados = vehiculosLocal.filter(vehiculo =>
    //             selVehiculosLocal.some(selVehiculo =>
    //                 typeof selVehiculo === 'object'
    //                     ? selVehiculo.value === vehiculo.value
    //                     : selVehiculo === vehiculo.value
    //             )
    //         );
    //         const filtradosSelected = vehiculosSeleccionados.filter(
    //             (vehiculo) => vehiculo.uid_grupo === grupossselec.value
    //         );
    //         editarSelVehiculosLocal(filtradosSelected);
    //         /*Filtrar elementos ya seleccionados*/
    //     } else {
    //         // Si no se selecciona grupo, mostrar todos los vehículos
    //         editarVehiculosLocalFiltrados(vehiculosLocal);
    //     }
    // }, [selGruposLocal, vehiculosLocal]);

    // Método para manejar cualquier Select
    const handleSelectChange = (selected, options, setSelected) => {
        const allSelected = selected.some(option => option.value === 'all');
        const todasLasOpciones = options.flatMap(grupo => grupo.options || grupo);

        if (allSelected) {
            if (selected.length === todasLasOpciones.length + 1) { // 🔹 Se suma 1 por la opción "Seleccionar todos"
                setSelected([]); // 🔹 Deseleccionar todo correctamente
            } else {
                setSelected(todasLasOpciones); // 🔹 Seleccionar todas las opciones ignorando los agrupadores
            }
        } else {
            setSelected(selected);
        }
    };

    // Al seleccionar los filtros, los pasamos al contenedor padre (index)
    const handleClickFilter = () => {
        if (selVehiculosLocal.length === 0)
            return;
        const fecha_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss")
        const fecha_fin = dayjs(endDate.getTime()).format("YYYY-MM-DDTHH:mm:ss")

        editarTipoVista(selTipoVista);
        editarGrupos(selGruposLocal);
        editarFechaInicio(fecha_inicio);
        editarFechaFin(fecha_fin);

        //obtener TODOS los vehículos seleccionados
        const vehiculosSeleccionadosCompletos = vehiculosLocal.filter(vehiculo =>
            selVehiculosLocal.some(selVehiculo =>
                typeof selVehiculo === 'object'
                    ? selVehiculo.value === vehiculo.value
                    : selVehiculo === vehiculo.value
            )
        );

        editarVehiculos(vehiculosSeleccionadosCompletos);
        generarBitacoraReporte(AccionBitacora.Generar);
        const decoded = jwtDecode(localStorage.getItem('token'));
        onGenerateReport(
            {
                fecha_inicio: fecha_inicio,
                fecha_fin: fecha_fin,
                ids_tipo_alerta: tipoAlertas,
                uids_vehiculo: selVehiculosLocal && selVehiculosLocal.length > 0 ? selVehiculosLocal : [],
                geocercas: geocercas,
                //uids_vehiculo: selVehiculosLocal && selVehiculosLocal.length > 0 ? selVehiculosLocal.map(v => v.value) : [],
                empresaUid: decoded.uid_empresa,
                page: 1,
                limit: 10000,
                uid_usuario: decoded.uid_usuario,
                perfil: 1,
                count: true,
            }
        );
    };


    useEffect(() => {
        guardarBitacora({ categoria: 'Reporte Usabilidad', observacion: 'Usabilidad', tipoAccion: AccionBitacora.EntrarReporte });
        window.guardarBitacoraPrint = () => {
            generarBitacoraReporte(AccionBitacora.Imprimir);
        };
        window.guardarBitacoraExport = () => {
            generarBitacoraReporte(AccionBitacora.Exportar);
        };
    }, []);
    const filtrosGenerarRef = useRef();
    const generarBitacoraReporte = (accion) => {
        if (accion === AccionBitacora.Generar) {
            let fecha_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
            let hora_inicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("HH:mm");
            let fecha_fin = dayjs(endDate.getTime()).tz(dayjs.tz.guess()).format("DD/MM/YYYY");
            let dataGrupos = (gruposLocal || []).filter(w => (selGruposLocal || []).includes(w.value));
            let dataVehiculos = (vehiculosLocal || []).filter(w => (selVehiculosLocal || []).includes(w.value));
            let dataAlertas = [];
            filtrosGenerarRef.current = { fecha_inicio, hora_inicio, fecha_fin, dataGrupos, dataVehiculos, dataAlertas };
        }
        guardarBitacora({
            categoria: 'Reporte Usabilidad',
            observacion: generarObservacion(
                'Usabilidad',
                {
                    fecha_inicio: filtrosGenerarRef.current.fecha_inicio,
                    hora_inicio: filtrosGenerarRef.current.hora_inicio,
                    fecha_fin: filtrosGenerarRef.current.fecha_fin,
                    grupos: filtrosGenerarRef.current.dataGrupos.map(w => w.label).join(', '),
                    vehiculos: filtrosGenerarRef.current.dataVehiculos.map(w => w.label).join(', '),
                    tipoAlertas: filtrosGenerarRef.current.dataAlertas.map(w => w.label).join(', '),
                }
            ),
            tipoAccion: accion
        });
    }
    //Inicializa la vista
    useEffect(() => {
        if (effectRan.current) return;
        effectRan.current = true;
        cargarGruposLocal();
        cargarVehiculosLocal();
        cargarTipoAlertas();
        loadGeocercas();
    }, []);

    // Handle functions for DatePicker onChange and custom header
    const handleStartDateChangeWrapper = useCallback((date) => {
        handleStartDateChange(date, startDate, endDate, setStartDate, setEndDate);
    }, [startDate, endDate]);
    const handleEndDateChangeWrapper = useCallback((date) => {
        handleEndDateChange(date, startDate, endDate, setStartDate, setEndDate);
    }, [startDate, endDate]);

    const renderIniHeader = useMemo(
        () => (props) => createRenderCustomHeader(startDate, handleStartDateChangeWrapper)(props),
        [startDate, handleStartDateChangeWrapper]
    );
    const renderEndHeader = useMemo(
        () => (props) => createRenderCustomHeader(endDate, handleEndDateChangeWrapper)(props),
        [endDate, handleEndDateChangeWrapper]
    );

    return (
        <div>
            <Row className='mb-3'>

                {dateRangeError && (
                    <Col xs={12}>
                        <div className="alert alert-warning py-2 my-2">
                            {dateRangeError}
                        </div>
                    </Col>
                )}

                <Col md={3} xs={4}>
                    <Form.Group>
                        <Form.Label>Desde</Form.Label>
                        <DatePicker
                            selected={startDate}
                            onChange={handleStartDateChangeWrapper}
                            customInput={<ExampleCustomInput />}
                            timeIntervals={5}
                            dateFormat="dd/MM/yyyy HH:mm:ss"
                            /* showTimeSelect */
                            renderCustomHeader={renderIniHeader}
                            maxDate={now}
                            fixedHeight
                            locale="es"
                            timeCaption="Hora"
                            minTime={new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0)}
                            maxTime={
                                (startDate.getDate() === now.getDate() && startDate.getMonth() === now.getMonth() && startDate.getFullYear() === now.getFullYear())
                                    ? now
                                    : new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 23, 59, 59)
                            }
                        />
                    </Form.Group>
                </Col>
                <Col md={3} xs={4}>
                    <Form.Group>
                        <Form.Label>Hasta</Form.Label>
                        <DatePicker
                            selected={endDate}
                            minDate={startDate}
                            minTime={
                                endDate.getDate() === startDate.getDate() && endDate.getMonth() === startDate.getMonth() && endDate.getFullYear() === startDate.getFullYear()
                                    ? startDate
                                    : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 0, 0, 0)
                            }
                            maxTime={
                                (endDate.getDate() === now.getDate() && endDate.getMonth() === now.getMonth() && endDate.getFullYear() === now.getFullYear())
                                    ? now
                                    : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59)
                            }
                            onChange={handleEndDateChangeWrapper}
                            customInput={<ExampleCustomInput />}
                            timeIntervals={5}
                            dateFormat="dd/MM/yyyy HH:mm:ss"
                            /* showTimeSelect */
                            renderCustomHeader={renderEndHeader}
                            maxDate={now}
                            fixedHeight
                            locale="es"
                            timeCaption="Hora"
                        />
                    </Form.Group>
                </Col>

                <Col md={3} xs={4} >
                    <Form.Label>Grupos</Form.Label>
                    <MultiSelect
                        className=" w-full md:w-20rem"
                        value={selGruposLocal || []}
                        onChange={(e) => {
                            editarSelGruposLocal(e.value);
                        }}
                        options={gruposLocal}
                        optionLabel="label"
                        filter
                        placeholder="Seleccione un grupo"
                        highlightOnSelect={false}
                        styles={customStyles}
                        maxSelectedLabels={2}
                        selectedItemsLabel={`${(selGruposLocal || []).length} grupos seleccionados`}
                    />
                </Col>


                <Col md={3} xs={4}>
                    <Form.Label>Vehículos</Form.Label>
                    <MultiSelect
                        className=" w-full md:w-20rem"
                        value={selVehiculosLocal || []}
                        onChange={(e) => {
                            editarSelVehiculosLocal(e.value);
                        }}
                        options={vehiculosLocalFiltrados}
                        optionLabel="label"
                        filter
                        placeholder="Seleccione un vehiculo"
                        highlightOnSelect={false}
                        styles={customStyles}
                        maxSelectedLabels={2}
                        selectedItemsLabel={`${(selVehiculosLocal || []).length} vehículos seleccionados`}
                    />
                </Col>

                {/* <Col md={3} xs={4}>
                    <Form.Group>
                        <Form.Label>Grupos</Form.Label>
                        <Select
                            key={'group-selector'}
                            closeMenuOnSelect={false}
                            options={[...gruposLocal]}
                            classNamePrefix="react-select"
                            placeholder='Seleccionar...'
                            isClearable="true"
                            value={selGruposLocal}
                            onChange={(selected) => editarSelGruposLocal(selected)}
                            styles={customStyles}
                        />
                    </Form.Group>
                </Col>

                <Col md={4} xs={4}>
                    <Form.Group>
                        <Form.Label>Vehículos</Form.Label>
                        <Select
                            closeMenuOnSelect={false}
                            options={[
                                ...(selVehiculosLocal.length !== vehiculosLocalFiltrados.length
                                    ? [{ value: 'all', label: 'Seleccionar todos' }]
                                    : [{ value: 'all', label: 'Deseleccionar todos' }]
                                ),
                                ...vehiculosLocalFiltrados
                            ]}
                            classNamePrefix="react-select"
                            placeholder='Seleccionar...'
                            value={selVehiculosLocal}
                            onChange={(selected) => handleSelectChange(selected, vehiculosLocalFiltrados, editarSelVehiculosLocal)}
                            isMulti
                            styles={customStyles}
                        />
                    </Form.Group>
                </Col> */}

                <Col md={2} xs={4} style={{ display: 'none' }}>
                    <Form.Group>
                        <Form.Label>Tipo de vista</Form.Label>
                        <Select
                            closeMenuOnSelect={false}
                            options={[...tiposVista]}
                            classNamePrefix={"react-select"}
                            placeholder='Seleccionar...'
                            value={selTipoVista}
                            onChange={(selected) => editarSelTipoVista(selected)}
                            styles={customStyles}
                        />
                    </Form.Group>
                </Col>
            </Row>

            <Row>

                <Col md={2} xs={4} className='ms-auto'>
                    <div className='mt-4 me-0'>
                        <Button variant="primary" className="w-100" onClick={handleClickFilter} disabled={paginadorRecorridos.cargando || selVehiculosLocal.length === 0 || !!dateRangeError}>
                            Generar
                        </Button>
                    </div>
                </Col>
                <Col md={2} xs={4}>
                    <div className="print-report d-flex mt-4" style={(imprimir || false) ? {} : { pointerEvents: 'none', opacity: 0.5 }}>
                    </div>
                </Col>

                {/* <Col md={2} xs={4}>
                    <Button 
                        variant="outline-info" 
                        size="sm" 
                        onClick={onToggleDebug}
                        className="ms-2"
                    >
                        <i className="fas fa-chart-line"></i> Debug
                    </Button>
                </Col> */}



            </Row>
        </div>
    );
}

export default FiltersNonWorkingHours;